import { Topics } from '../../../../models/LocalNotificationTopics';
import { ILocalNotification } from '../../../../models/LocalNotifications';
import { baseStyleSheet } from '../../../styles/styles';
import { LoadingSpinner } from '../../LoadingSpinner';
import { LocalNotificationObserver } from '../../LocalNotificationObserver';
import { DefaultSelectBox, ISelectBoxOption } from '../../SelectBox';
import { UserFilterSelectBox } from '../../UserFilterSelectBox';
import { UserSelectModal } from '../../UserSelectModal';
import { useSocialReporting } from './hooks/useSocialReporting';
import { styleSheet } from './styles';
import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';

const POST_STATUS_OPTIONS: ISelectBoxOption<Api.ReportPostStatus>[] = [
	{
		title: 'All Posts',
		value: Api.ReportPostStatus.All,
	},
	{
		title: 'Scheduled',
		value: Api.ReportPostStatus.Scheduled,
	},
	{
		title: 'Posted',
		value: Api.ReportPostStatus.Posted,
	},
	{
		title: 'Pending',
		value: Api.ReportPostStatus.Pending,
	},
	{
		title: 'Cancelled',
		value: Api.ReportPostStatus.Cancelled,
	},
	{
		title: 'Failed',
		value: Api.ReportPostStatus.Failed,
	},
];

const isPosted = (postStatus: Api.PostStatus[]) => {
	return postStatus.find(
		x => x === Api.PostStatus.Succeeded || x === Api.PostStatus.PartiallySucceeded || x === Api.PostStatus.Started
	);
};

type IProps = ReturnType<typeof useSocialReporting> & {
	children: React.ReactNode;
};

export const SocialMediaReportingTable = ({
	onClearFilters,
	onSentByModalRequestClose,
	onStatusFilterChanged,
	onUserFilterChanged,
	selectedPostStatus,
	selectedUser,
	showingSentByModal,
	socialMediaPostsQuery,
	children,
}: IProps) => {
	const renderFilters = () => {
		const selectedStatusOption = POST_STATUS_OPTIONS.find(
			x =>
				x.title ===
				(selectedPostStatus?.length > 0
					? isPosted(selectedPostStatus)
						? 'Posted'
						: selectedPostStatus[0]
					: 'All Posts')
		);
		return (
			<div className={css(styleSheet.filter)}>
				{'Filter By: '}
				<DefaultSelectBox
					onSelectionChanged={onStatusFilterChanged}
					options={POST_STATUS_OPTIONS}
					menuStyles={[styleSheet.filterDropdownMenu]}
					selectedOption={selectedStatusOption}
					triggerStyles={[styleSheet.filterDropdownTrigger]}
				/>
				<UserFilterSelectBox selectedUser={selectedUser} onSelectionChanged={onUserFilterChanged} />
				<UserSelectModal
					modalProps={{
						isOpen: showingSentByModal,
						onRequestClose: onSentByModalRequestClose,
					}}
					title='Select an Employee'
				/>
				<div className={css(styleSheet.clearFiltersContainer)}>
					<button onClick={onClearFilters}>Clear all filters</button>
				</div>
			</div>
		);
	};

	const onNotification = (notification: ILocalNotification<string>) => {
		if (notification.topic === Topics.EDIT_SOCIAL_POST) {
			socialMediaPostsQuery.refetch();
		}
	};

	return (
		<>
			{renderFilters()}
			{socialMediaPostsQuery.status === 'success' ? (
				<>
					<div className={css(baseStyleSheet.tableColumnHeader, styleSheet.header)}>
						<div className={css(styleSheet.nameColumn)}>Post Title/Status</div>
						<div className={css(styleSheet.platformColumn)}>Platform(s)/Account Used</div>
						<div className={css(styleSheet.platformColumn)}>View Post On Platform</div>
					</div>
					<div className={css(styleSheet.body)}>
						{children}
						{socialMediaPostsQuery.isFetchingNextPage && (
							<LoadingSpinner className={css(styleSheet.loading)} type='large' />
						)}
					</div>
				</>
			) : (
				<div className={css(styleSheet.noneFound)}>No Posts Found</div>
			)}
			<LocalNotificationObserver onNotificationReceived={onNotification} topic={Topics.EDIT_SOCIAL_POST} />
		</>
	);
};
